import { render, staticRenderFns } from "./properties.vue?vue&type=template&id=4b0511d1&scoped=true&"
import script from "./properties.vue?vue&type=script&lang=js&"
export * from "./properties.vue?vue&type=script&lang=js&"
import style0 from "./properties.vue?vue&type=style&index=0&id=4b0511d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0511d1",
  null
  
)

export default component.exports